<script lang="ts">
    import type {SearchParams, StaticSearchParams} from 'typings/portaro.be.types';
    import type {SearchManager} from '../search-manager/search-manager';
    import {getInjector} from 'core/svelte-context/context';
    import {setSearchContext, getSearchContextConnector} from './search-context';
    import {SearchManagerBuilderFactoryService} from '../search-manager/search-manager-factory.service';
    import {exists} from 'shared/utils/custom-utils';

    export let staticParams: Partial<StaticSearchParams> | undefined;
    export let localSearch = false;
    const service = getInjector().getByClass(SearchManagerBuilderFactoryService);

    const searchManagerBuilder = service.createBuilder<SearchParams, any>().withStaticParams(staticParams);
    const searchManager = localSearch ? searchManagerBuilder.createLocalSearch(true) : searchManagerBuilder.createGlobalSearch();

    setSearchContext(searchManager);

    const searchContextConnector = getSearchContextConnector();
    if (exists(searchContextConnector)) {
        searchContextConnector.set(searchManager);
    }

    export function getSearchManager(): SearchManager<any> {
        return searchManager;
    }
</script>

<slot {searchManager}/>